import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useState } from "react";
import Logo from "./Logo";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const onLanding = pathname === "/";

  const link = (to, label, id) => (
    <Link to={to} data-testid={`nav-${id}`} className="ulink text-[14px] tracking-wide text-[#1A1A1A]">
      {label}
    </Link>
  );

  const anchor = (href, label, id) => (
    <a href={href} data-testid={`nav-${id}`} className="ulink text-[14px] tracking-wide text-[#1A1A1A]">
      {label}
    </a>
  );

  return (
    <header className="bg-white sticky top-0 z-50 border-b border-[#EBE8DF]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-[68px] flex items-center justify-between">
        <Link to="/" data-testid="nav-logo-home" className="flex items-center">
          <Logo height={36} />
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {onLanding ? anchor("#concepts", "Concepts", "concepts") : link("/#concepts", "Concepts", "concepts")}
          {link("/framework", "Framework", "framework")}
          {link("/ai-search", "AI Search", "ai-search")}
          {link("/pricing", "Get a Quote", "pricing")}
          {onLanding ? anchor("#contact", "Contact", "contact") : link("/#contact", "Contact", "contact")}
        </nav>

        <div className="hidden md:flex items-center gap-4">
          <Link to="/portal/login" data-testid="nav-portal-login" className="text-[14px] tracking-wide text-[#5C5C5C] hover:text-[#1A1A1A] transition-colors">
            Client Portal
          </Link>
          <a href={onLanding ? "#contact" : "/#contact"} data-testid="nav-book-cta" className="btn-primary text-[14px] py-3 px-5">
            Book a consult
          </a>
        </div>

        {/* Mobile: compact CTA + hamburger */}
        <div className="md:hidden flex items-center gap-2">
          <a href={onLanding ? "#contact" : "/#contact"} data-testid="nav-mobile-cta" className="btn-gold text-[12px] py-2 px-4">
            Book
          </a>
          <button onClick={() => setOpen(!open)} className="p-2 -mr-2" data-testid="nav-mobile-toggle" aria-label="Toggle menu">
            {open ? <X size={22}/> : <Menu size={22}/>}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-[#EBE8DF] bg-white px-6 py-6 space-y-4">
          {anchor("#concepts", "Concepts", "m-concepts")}
          <div /><Link to="/framework" data-testid="nav-m-framework" className="block">Framework</Link>
          <Link to="/ai-search" data-testid="nav-m-aisearch" className="block">AI Search</Link>
          <Link to="/pricing" data-testid="nav-m-pricing" className="block">Get a Quote</Link>
          <Link to="/portal/login" data-testid="nav-m-portal" className="block">Client Portal</Link>
          <a href="#contact" data-testid="nav-m-book" className="btn-primary inline-flex">Book a consult</a>
        </div>
      )}
    </header>
  );
}
